// 知识库分类
<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
					@reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height"  style="height: calc(100vh - -35px);">
          <vxe-table
            resizable
            show-overflow
            keep-source
            ref="xTable"
            row-id="id"
            :print-config="{}"
            :export-config="{}"
            :loading="loading"
            :tree-config="{transform: true, rowField: 'id', parentField: 'parentId'}"
            :edit-config="{trigger: 'click', mode: 'row', showStatus: true}"
            :data="tableData">
            <vxe-column type="checkbox" width="60" tree-node></vxe-column>
            <vxe-column field="name" title="Name" >
              <template #edit="{ row }" :edit-render="{}">
                <vxe-input v-model="row.name" type="text"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column field="size" title="Size" :edit-render="{}">
              <template #edit="{ row }">
                <vxe-input v-model="row.size" type="text"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column field="type" title="Type" :edit-render="{}">
              <template #edit="{ row }">
                <vxe-input v-model="row.type" type="text"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column field="date" title="Date" :edit-render="{}">
              <template #edit="{ row }">
                <vxe-input v-model="row.date" type="date" transfer></vxe-input>
              </template>
            </vxe-column>
            <vxe-column title="操作" width="500">
              <template #default="{ row }">
                <vxe-button type="text" status="primary" @click="insertRow(row, 'current')">插入节点</vxe-button>
                <vxe-button type="text" status="primary" @click="insertRow(row, 'top')">顶部插入节点</vxe-button>
                <vxe-button type="text" status="primary" @click="insertRow(row, 'bottom')">尾部插入子节点</vxe-button>
                <vxe-button type="text" status="primary" @click="removeRow(row)">删除节点</vxe-button>
              </template>
            </vxe-column>
          </vxe-table>


          <!--					<vxe-grid-->
<!--					:stripe="true" border="default" :row-config="{ isHover: true }" show-overflow height="100%"-->
<!--					ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"-->
<!--						@custom="$vxeTableUtil.customHandle">-->

<!--						<template #form>-->
<!--							<div class="clearfix screen-btns">-->
<!--								<div class="fl">-->
<!--									<vxe-button status="primary" class="button-sty" icon="el-icon-plus"-->
<!--										@click="openEditDialog">新增</vxe-button>-->
<!--								</div>-->
<!--								<div class="fr">-->
<!--									<vxe-button status="warning" icon="el-icon-search" class="button-sty"-->
<!--										@click="searchEvent">搜索</vxe-button>-->
<!--								</div>-->
<!--							</div>-->
<!--							<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"-->
<!--								@submit="searchEvent" @reset="searchEvent">-->
<!--								<vxe-form-item title="分类名称:" field="name">-->
<!--									<template v-slot>-->
<!--										<el-input v-model="searchProjectName" size="small" clearable />-->
<!--									</template>-->
<!--								</vxe-form-item>-->
<!--								<vxe-form-item title="上级分类:" field="name">-->
<!--									<template v-slot>-->
<!--										<el-input v-model="searchProjectCode" size="small" clearable />-->
<!--									</template>-->
<!--								</vxe-form-item>-->
<!--							</vxe-form>-->
<!--						</template>-->
<!--						<template #pager>-->
<!--              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>-->
<!--            </template>-->
<!--					</vxe-grid>-->
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import editView from './edit.vue';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'

import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'

export default {
	components: { editView, pager },
	data() {
		return {
      loading: false,
      tableData: [],


      total: 0,
			activeName: 'second',
			dataId: 0,
      pageSizes: [10, 20, 100],
      gridData: {},
			showEdit: false,
      editViewDataUpdateFlag: false,
			vxeOption: {},
      searchProjectCode:'',
      searchProjectName:'',
			// 查询参数
			formData: {
				searchCount: false,  // 是否分页
				current: 1,  // 当前页面
				size: 0,  // 页面数据量
        projectCode:'',
        projectName:''
			},
		};
	},
	mounted() {
		this.findList();
	},
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.initTableList()
      }
    }
  },
	methods: {
    findList () {
      this.loading = true
      return new Promise(resolve => {
        this.$http({
          url: api.basKnowledgeType
        })
        setTimeout(() => {
          this.tableData = [
            { id: 10000, parentId: null, name: 'vxe-table test abc1', type: 'mp3', size: 1024, date: '2020-08-01' },
            { id: 10050, parentId: null, name: 'Test2', type: 'mp4', size: null, date: '2021-04-01' },
            { id: 24300, parentId: 10050, name: 'Test3', type: 'avi', size: 1024, date: '2020-03-01' },
            { id: 20045, parentId: 24300, name: 'vxe-table test abc4', type: 'html', size: 600, date: '2021-04-01' },
            { id: 10053, parentId: 24300, name: 'vxe-table test abc96', type: 'avi', size: null, date: '2021-04-01' },
            { id: 24330, parentId: 10053, name: 'vxe-table test abc5', type: 'txt', size: 25, date: '2021-10-01' },
            { id: 21011, parentId: 10053, name: 'Test6', type: 'pdf', size: 512, date: '2020-01-01' },
            { id: 22200, parentId: 10053, name: 'Test7', type: 'js', size: 1024, date: '2021-06-01' },
            { id: 23666, parentId: null, name: 'Test8', type: 'xlsx', size: 2048, date: '2020-11-01' },
            { id: 23677, parentId: 23666, name: 'Test7', type: 'js', size: 1024, date: '2021-06-01' },
            { id: 23671, parentId: 23677, name: 'Test7', type: 'js', size: 1024, date: '2021-06-01' },
            { id: 23672, parentId: 23677, name: 'Test7', type: 'js', size: 1024, date: '2021-06-01' },
            { id: 23688, parentId: 23666, name: 'Test7', type: 'js', size: 1024, date: '2021-06-01' },
            { id: 23681, parentId: 23688, name: 'Test7', type: 'js', size: 1024, date: '2021-06-01' },
            { id: 23682, parentId: 23688, name: 'Test7', type: 'js', size: 1024, date: '2021-06-01' },
            { id: 24555, parentId: null, name: 'vxe-table test abc9', type: 'avi', size: 224, date: '2020-10-01' },
            { id: 24566, parentId: 24555, name: 'Test7', type: 'js', size: 1024, date: '2021-06-01' },
            { id: 24577, parentId: 24555, name: 'Test7', type: 'js', size: 1024, date: '2021-06-01' }
          ]
          this.loading = false
          resolve()
        }, 300)
      })
    },
    async insertRow (currRow, locat) {
      const $table = this.$refs.xTable
      // 如果 null 则插入到目标节点顶部
      // 如果 -1 则插入到目标节点底部
      // 如果 row 则有插入到效的目标节点该行的位置
      if (locat === 'current') {
        const record = {
          name: '新数据',
          id: Date.now(),
          parentId: currRow.parentId, // 父节点必须与当前行一致
          date: XEUtils.toDateString(new Date(), 'yyyy-MM-dd')
        }
        const { row: newRow } = await $table.insertAt(record, currRow)
        await $table.setActiveRow(newRow) // 插入子节点
      } else if (locat === 'top') {
        const record = {
          name: '新数据',
          id: Date.now(),
          parentId: currRow.id, // 需要指定父节点，自动插入该节点中
          date: XEUtils.toDateString(new Date(), 'yyyy-MM-dd')
        }
        const { row: newRow } = await $table.insert(record)
        await $table.setTreeExpand(currRow, true) // 将父节点展开
        await $table.setActiveRow(newRow) // 插入子节点
      } else if (locat === 'bottom') {
        const record = {
          name: '新数据',
          id: Date.now(),
          parentId: currRow.id, // 需要指定父节点，自动插入该节点中
          date: XEUtils.toDateString(new Date(), 'yyyy-MM-dd')
        }
        const { row: newRow } = await $table.insertAt(record, -1)
        await $table.setTreeExpand(currRow, true) // 将父节点展开
        await $table.setActiveRow(newRow) // 插入子节点
      }
    },





    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

		// 分页功能
		changeTablePage(page, flag) {
			console.log('分页数据', page, this.formData)
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.initTableList();
		},
		// 搜索
		searchEvent() {
      this.formData.projectCode = this.searchProjectCode
      this.formData.projectName = this.searchProjectName
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()

		},
		// 重置
		resetEvent() {
      this.formData.searchCount = false
      this.formData.current= 1
      this.formData.projectCode = ''
      this.formData.projectName = ''
      this.searchProjectCode = ''
      this.searchProjectName = ''
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
		},
		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
		initTableList() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/basic/basRecallProject/getListPage',
				param: this.formData,
				method: 'post',
				height: '800px',
				columns: [
					{ type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
					{
						title: '分类名称',
						field: 'projectName',
						width: 150,
						fixed: 'left'
					},
					{
						title: '上级分类',
						field: 'projectCode',
						width: 150,
					},
					// {
					// 	title: '值类型',
					// 	field: 'valueType',
					// 	width: 150,
					// 	slots: {
					// 		default: ({ row }) => {
					// 			if (row.valueType == 1) {
					// 				return [
					// 					<div>
					// 						<span>选项值</span>
					// 					</div>
					// 				];
					// 			} else if (row.valueType == 2) {
					// 				return [
					// 					<div>
					// 						<span>文本</span>
					// 					</div>
					// 				];
					// 			}
					// 		}
					// 	}
					// },
					// {
					// 	title: '选项值',
					// 	field: 'valueSplit',
					// 	width: 150,
					// 	slots: {
					// 		default: ({ row }) => {
					// 			if (row.valueSplit == 1) {
					// 				return [
					// 					<div>
					// 						<span>审单</span>
					// 					</div>
					// 				];
					// 			} else if (row.valueSplit == 2) {
					// 				return [
					// 					<div>
					// 						<span>回访</span>
					// 					</div>
					// 				];
					// 			}
					// 		}
					// 	}
					// },
					{
						title: '启用',
						field: 'usable',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.usable == 0) {
									return [
										<div class="txt-status disable">
											<span>禁用</span>
										</div>
									];
								} else if (row.usable == 1) {
									return [
										<div class="txt-status">
											<span>启用</span>
										</div>
									];
								}
							}
						}
					},


					{
						field: 'createTime',
						title: '创建时间',
						width: 150
					},
					{
						title: '创建人',
						field: 'createBy',
						width: 150,

					},
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<div>
										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.openEditDialog(row.id);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-edit" />
											</el-tooltip>
										</a>
									</div>
								];
							}
						}
					}
				]
			};
			// initVxeTable(tableOption).then(opts => {
			this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
		},
	}
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}</style>
